import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import './styles.css';

const ProjLargeOffsetImage = ({src, setPosition, size, aspectRatio, setLeft=null, setWidth = "70%", setPadding="0 0 125px 0"}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [useSrc, setUseSrc] = useState(null);

    useEffect(() => {
        if(size){
            let tmp = src.replace("mobile", size);
            setUseSrc(tmp);
        }
    }, [size])

    const imgVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0
            }
        }, exit: {
            opacity: 0
        }
    }


    return(
        <>
            { useSrc &&
            <div 
                className="proj-lrg-offset__wrapper"
                style={{
                    padding: setPadding
                }}
            >
                <div style={{
                    position: 'relative', width: '100%', height: '100%',
                    aspectRatio: aspectRatio
                    
                }}>
                    <img   
                        src={src.replace('mobile', 'placeholder')} 
                        style={{
                            width: setWidth,
                            position: "relative",
                            height: "auto",
                            left: setLeft ? setLeft : setPosition == "left" ? 0 : setPosition == "center" ? "50%" : `calc(100% - ${setWidth})`,
                        }}
                    />
                    <motion.img 
                        initial="initial"
                        animate={isLoaded ? "animate" : "initial"}
                        exit="exit"
                        variants={imgVariants}
                        src={useSrc} 
                        onLoad={(e) => {
                            setIsLoaded(true);
                        } }
                        style={{
                            position: "absolute",
                            top: 0,
                            width: setWidth,
                            height: "auto",
                            left: setLeft ? setLeft : setPosition == "left" ? 0 : setPosition == "center" ? "50%" : `calc(100% - ${setWidth})`,
                        }}
                    />
                </div>
            </div>
            }
        </>
    )
}

export default ProjLargeOffsetImage;